import { Link } from 'react-router-dom';
import type { Movie } from '@/lib/movieTypes';
import { formatCount } from '@/lib/movieUtils';

interface HotRankListProps {
  movies: Movie[];
}

export default function HotRankList({ movies }: HotRankListProps) {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-1 h-7 rounded-full bg-accent-500"></span>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">热门推荐</h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-0.5">按播放热度精选，最受欢迎的国语影音资源</p>
        </div>
      </div>
      <div className="bg-background-50 border border-background-200 rounded-lg divide-y divide-background-200 overflow-hidden">
        {movies.map((movie, i) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="flex items-center gap-3 md:gap-4 p-3 md:p-4 hover:bg-background-100 transition-colors"
          >
            <span
              className={`w-7 text-center font-heading text-lg md:text-xl font-bold ${
                i < 3 ? 'text-accent-500' : 'text-foreground-400'
              }`}
            >
              {i + 1}
            </span>
            <span className="w-14 h-20 md:w-16 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-100">
              <img
                src={movie.cover}
                alt={`${movie.title} 封面`}
                title={`${movie.title} 热门国语影音`}
                className="w-full h-full object-cover object-top"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm md:text-base font-semibold text-foreground-950 truncate">
                {movie.title}
              </span>
              <span className="mt-1 flex items-center flex-wrap gap-x-3 gap-y-1 text-xs text-foreground-500">
                <span className="whitespace-nowrap">{movie.typeName} · {movie.subCategoryName}</span>
                <span className="whitespace-nowrap">{movie.year}</span>
                <span className="whitespace-nowrap flex items-center gap-1 text-accent-600">
                  <i className="ri-fire-line"></i>
                  {formatCount(movie.playCount)}
                </span>
              </span>
              <span className="mt-1 block text-xs text-foreground-600 truncate">{movie.summary}</span>
            </span>
            <i className="ri-arrow-right-s-line text-foreground-300 text-xl shrink-0"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}